module.exports = __webpack_public_path__ + "img/picto-events.f4ede571.svg";